'use client';

import { Box, Card, FeaturedImage, Grid, NumberButtons, Typography } from '@repo/ui';
import { useState } from 'react';
import Image from 'next/image';
import { usePaymentStore } from '@/store/mutable-data/payment/PaymentStoreContext';
import PricingCard from '../PricingCard';
import styles from './PricingCalculator.module.scss';

const PricingCalculator = () => {
    const payment = usePaymentStore();

    const [selectedNumberOfArticles, setSelectedNumberOfArticles] = useState<number>(1);

    const onArticleNumberClick = (selectedButton: number) => {
        setSelectedNumberOfArticles(selectedButton);
    };

    const pricePerArticle = payment.paymentCart[0]?.total;
    const packageItem = payment.paymentCart[0]?.items[0]?.item;

    return (
        <Grid container>
            <Grid item flex={3}>
                <Card style={{ height: '100%' }}>
                    <Box display="flex" alignItems="center">
                        <Box display="flex" height={240} margin="0 1rem 0 0">
                            <FeaturedImage
                                Image={Image}
                                src={packageItem?.image || '/favicon.png'}
                                alt="MindLess Writer per article package"
                                lazyLoad={false}
                                quality={100}
                                width={320}
                                height={240}
                            />
                        </Box>

                        <Box>
                            <Typography variant="h2" fontSize="2rem" margin="0 0 0.5rem 0">
                                How many articles* do you need?
                            </Typography>

                            <Typography margin="0 0 1.5rem 0">
                                {packageItem?.description}
                            </Typography>

                            <NumberButtons
                                numberOfButtons={5}
                                onClick={onArticleNumberClick}
                                selectedButton={selectedNumberOfArticles}
                            />

                            <Typography className={styles['fade-text']} margin="1.5rem 0 0 0">
                                * 1 AI Article = 1 AI Credit
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Grid>

            <Grid item flex={1}>
                <Card style={{ backgroundColor: 'var(--secondary-color)', height: '100%' }}>
                    <PricingCard
                        price={packageItem?.price}
                        discount={packageItem?.discount}
                        // discountedPrice={packageItem?.discountedPrice}
                        discountedPrice={pricePerArticle * selectedNumberOfArticles}
                        planId={packageItem?.id}
                        qty={selectedNumberOfArticles}
                        topTitle="Your price"
                    />
                </Card>
            </Grid>
        </Grid>
    );
};

export default PricingCalculator;
